import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Suppress benign ResizeObserver loop warning that triggers the CRA dev error overlay
const roMsg = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes(roMsg)) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
